import { concat } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  useGetComponentsWithPagination,
  useGetComponentTypesWithPagination,
  useParamQuery,
  useUpdateComponentTags,
} from 'src/hooks';
import { useCreateComponentTag } from 'src/hooks/api/componentTags/useCreateComponentTag';
import { IComponentType } from 'src/interfaces';
import { formatQuery } from 'src/utils';

export const useCreateComponentTagPage = () => {
  const { onChangeParams } = useParamQuery();
  const location = useLocation();

  const {
    data,
    isLoading: isLoadingComponents,
    error: errorLoadingComponents,
    hasNextPage,
    fetchNextPage,
  } = useGetComponentsWithPagination(
    concat(formatQuery(location.search), ['sort=-created_at']),
  );

  const createComponentTag = useCreateComponentTag();
  const updateComponent = useUpdateComponentTags();

  const [componentTypesPage, setComponentTypesPage] = useState({
    data: [] as IComponentType[],
    page: 1,
    totalPages: 1,
  });

  const {
    data: componentTypesData,
    isLoading: isLoadingComponentTypes,
    error: errorLoadingComponentTypes,
  } = useGetComponentTypesWithPagination([`page=${componentTypesPage.page}`], {
    staleTime: Infinity,
  });

  useEffect(() => {
    if (componentTypesData && componentTypesData.data) {
      setComponentTypesPage({
        ...componentTypesPage,
        data: [...componentTypesPage.data, ...componentTypesData.data],
        totalPages: componentTypesData.totalPages,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [componentTypesData, setComponentTypesPage]);

  const getNextComponentPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage]);

  return {
    data,
    isLoadingComponents,
    errorLoadingComponents,
    hasNextPage,
    fetchNextPage,
    getNextComponentPage,
    componentTypesPage,
    isLoadingComponentTypes,
    errorLoadingComponentTypes,
    onChangeParams,
    createComponentTag,
    updateComponent,
  };
};
